import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ============ GET PLATFORM FEE ============
const requested = createAction("platformFees/requested")
const received = createAction("platformFees/received")
const failed = createAction("platformFees/failed")

// ============ SAVE PLATFORM FEE (PATCH) ============
const requestedSave = createAction("platformFees/requestedSave")
const receivedSave = createAction("platformFees/receivedSave")
const failedSave = createAction("platformFees/failedSave")

// ============ INITIAL STATE ============
const initialState = {
  ...LOADING_INITIAL_STATE,
  data: null,
  save: {
    ...LOADING_INITIAL_STATE
  }
}

// ============ REDUCER ============
const platformFeesReducer = createReducer(initialState, {
  [requested.type]: (state) => {
    setRequested(state)
  },
  [received.type]: (state, { payload }) => {
    setReceived(state)
    state.data = payload.data ?? payload
  },
  [failed.type]: (state) => {
    setFailed(state)
  },

  [requestedSave.type]: (state) => {
    setRequested(state.save)
  },
  [receivedSave.type]: (state, { payload }) => {
    setReceived(state.save)
    state.data = payload.data ?? payload
  },
  [failedSave.type]: (state) => {
    setFailed(state.save)
  }
})

export default platformFeesReducer

// ============ API ACTIONS ============

export const getPlatformFee = () =>
  api({
    url: "/guide/settings/platform_fee",
    method: "get",
    onStart: requested.type,
    onSuccess: received.type,
    onError: failed.type
  })

export const savePlatformFee = (data) =>
  api({
    url: "/guide/settings/platform_fee",
    method: "patch",
    data: { platform_fee: data },
    onStart: requestedSave.type,
    onSuccess: receivedSave.type,
    onError: failedSave.type,
    showSuccessNotification: true
  })
